import { theme } from "../../theme";
export const genericListItem = {
    attendeeDetails: {
      display: "flex",
      alignItems: "center",
    },
    attendeeName: {
      fontWeight: "bold",
      fontSize: "16px",
    },
    attendeeTitle: {},
    attendeeCompany: {
      fontWeight: "lighter",
      wordBreak: "break-word",
    },
    registrationStatus: {
      fontSize: "10px",
      paddingLeft: "5px",
      paddingRight: "5px",
      borderRadius: "5px",
      color: "#fff",
    },
    active: {
      backgroundColor: theme.palette.primary.main,
    },
    attendeeAvatar: {
      // backgroundColor: theme.palette.primary.main,
      marginRight: "14px",
    },
    checkedAvatar: {
      backgroundColor: theme.palette.primary.main,
      marginRight: "16px",
    },
    actions: {
      paddingLeft: "10px",
      textAlign: "right",
      display: "flex",
      alignItems: "center",
    },
    actionIcon: {
      marginLeft: "10px",
      zIndex: 10,
      fontSize: "16px",
    },
    viewIcon: {
      visibility: "hidden",
    },
    activeRow: {
      "& attendeeAvatar": {
        backgroundColor: "#fff",
        color: theme.palette.primary.main,
      },
      "& attendeeDetails": {
        color: "#fff",
      },
    },
    checkboxIcon: {
      display: "none",
      position: "relative",
    },
    avatarIcon: {
      minWidth: "initial",
    },
    whiteCheckboxInput: { color: "#fff" },
    greyCheckboxInput: { color: `${theme.palette.grey[800]}` },
    listItemAction: {
      "&.Mui-selected": {
        backgroundColor: `${theme.palette.primary.main} !important`,
        color: "#fff !important",
      },
      "&:hover": {
        backgroundColor: `${theme.palette.primary.main} !important`,
        color: "#fff !important",
      },
        '&.attendeeRow':{
          '&:hover':{
            "& .attendeeAvatar": {
              backgroundColor: "#fff",
              color: theme.palette.primary.main,
            },
            "& .attendeeDetails": {
              color: "#fff",
            },
            "& .actionIcon": {
              color: "#fff",
            },
            "& .viewIcon": {
              visibility: "visible",
            },
            "& .checkboxIcon": {
              display: "block",
              left:'13px', 
            },
           
            "& .avatarIcon": {
              display: "none",
            },
            "& .greyCheckboxInput":{
              color: "#fff",
            }
          }
        },
        '&.activeRow':{
          "& .attendeeAvatar": {
            backgroundColor: "#fff",
            color: theme.palette.primary.main,
          },
          "& .attendeeDetails": {
            color: "#fff",
          },
          "& .greyCheckboxInput":{
            color: "#fff",
          }
        }
      
      }
  };